<script>
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {paginationMixin} from "@/mixins/paginationMixin";
import {gateMixin} from "@/mixins/gateMixin";
import DownloadPDFLoading from "@/components/elements/DownloadPDFLoading.vue";
import appLoading from "@/components/elements/AppLoading.vue";
import {mapActions, mapGetters, mapMutations} from "vuex";
import DownloadExcelLoading from "@/components/elements/DownloadExcelLoading.vue";
import {ReportService} from "@/services/ReportService";
export default {
  name: "CrewAccounts",
  mixins: [vueAppMixin, paginationMixin, gateMixin],
  components: {DownloadExcelLoading, appLoading, 'download-pdf-loading': DownloadPDFLoading},

  data() {
    return {
      activeCrews: [],
      params: {
        manning_id: "",
        status: 1
      }
    }
  },

  methods: {
    ...mapActions([
      'getRankKeys',
      'getActivityCodeKeys',
      'getCrewAccounts',
      'getManningKeys',
      'setLoading'
    ]),

    ...mapMutations([
        "setCrewAccounts",
        "setPagination"
    ]),

    async setPage(page) {
      this.pagination.currentPage = page;
      await this.refreshList();
    },

    async refreshList() {
      this.setLoading(true);
      this.params.page = this.pagination.currentPage;
      await this.getCrewAccounts(this.params);
      this.setLoading(false);
    },

    async resetList() {
      await this.setPage(1);
    },

    async downloadList(format) {
      this.params.format = format;
      this.params.manning_name = this.manningKeys.find(manning => manning.id === this.params.manning_id).alias;
      if (format === 'pdf') {
        document.querySelector("#LoadingModal").style.display = 'block';
        await ReportService.generateActiveCrewAccountsList(this.params);
        document.querySelector("#LoadingModal").style.display = "none";
      } else if (format === 'excel') {
        document.querySelector("#LoadingModalExcel").style.display = "block";
        await ReportService.generateActiveCrewAccountsList(this.params);
        document.querySelector("#LoadingModalExcel").style.display = "none";
      }
    }
  },

  computed: {
    ...mapGetters([
      'rankKeys',
      'crewAccounts',
      'activityCodeKeys',
      'manningKeys',
      'pagination'
    ]),

    generateMode() {
      return this.pagination.from === null || this.pagination.from === 0 || this.isLoading || this.params.manning_id === ""
    },

    paginationPages() {
      let pages = [];
      let currentPage = this.pagination.currentPage;
      let lastPage = this.pagination.lastPage;
      if (lastPage > 1) {
        let initialLimit = 1;
        if (currentPage + 5 > lastPage) {
          initialLimit = lastPage - 10;
        } else if (currentPage > 6) {
          initialLimit = currentPage - 5;
        }
        initialLimit = initialLimit < 1 ? 1 : initialLimit;
        for (let i = initialLimit; i <= initialLimit + 10; i++) {
          pages.push(i);
          if (i >= lastPage) {
            break;
          }
        }
      }
      return pages;
    },
    getManningLists(){
      return this.manningKeys.filter((manning)=>{
        return this.isKline ? ![7,17].includes(manning.id) : true
      })
    }
  },

  created() {
    this.setLoading(false);
    this.getActivityCodeKeys();
    this.getManningKeys();
    this.getRankKeys();
    this.setPagination({
      from: 0,
      to: 0,
      currentPage: 0,
      lastPage: 0,
      perPage: 0,
      total: 0
    });
  },

  destroyed () {
    this.setCrewAccounts([]);
    this.setPagination({
      from: 0,
      to: 0,
      currentPage: 0,
      lastPage: 0,
      perPage: 0,
      total: 0
    });
  }
}
</script>

<template>
  <div class="container-fluid m-0 p-0">
    <div class="row text-left bg-light border-bottom py-3 d-flex justify-content-between">
      <div class="col-auto">
        <h5 class="mb-0 font-weight-bold">Active Crew Profiling</h5>
      </div>
      <div class="col-auto">
        <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                @click="goBack"
        >
          <span class="fas fa-backward"></span>
          Go Back
        </button>
      </div>
    </div>

    <div class="row py-2">
      <div class="col-12 text-left">
        <div class="form-inline d-flex justify-content-start w-100">
          <div class="form-group py-1 mr-3">
            <label for="manningAgent" class="form-control-xs font-weight-bold">
              Manning Agent:
            </label>
            <select id="manningAgent"
                    v-model="params.manning_id"
                    @change="resetList"
                    :disabled="isLoading"
                    class="form-control form-control-xs mx-2">
              <option value="">--- SELECT MANNING ---</option>
              <option v-for="key in getManningLists" :key="key.id" :value="key.id">{{ key.alias }}</option>
            </select>
          </div>
          <div class="form-group py-1 mr-3">
            <label for="rank" class="form-control-xs font-weight-bold">
              Rank:
            </label>
            <select v-model="params.rank_id" id="rank" class="form-control form-control-xs mx-2" :disabled="isLoading || params.manning_id === ''"
              @change="resetList"
            >
              <option :value="undefined">--- ALL RANKS ---</option>
              <option v-for="key in rankKeys" :key="key.id" :value="key.id">{{ key.name }}</option>
            </select>
          </div>
          <div class="form-group py-1 mr-3">
            <label for="vessels" class="form-control-xs font-weight-bold">Activity Status: </label>
            <select class="form-control form-control-xs mx-2" id="vessels"
                    v-model="params.activity_code_id" :disabled="isLoading || params.manning_id === ''"
                    @change="resetList">
              <option :value="undefined">--- ALL ACTIVITY STATUSES ---</option>
              <option v-for="key in activityCodeKeys" :key="key.id" :value="key.id">{{ key.name }}</option>
            </select>
          </div>
          <div class="form-group py-1 mr-3">
            <label for="vessels" class="form-control-xs font-weight-bold">Account Status: </label>
            <select class="form-control form-control-xs mx-2" id="vessels"
                    v-model="params.status" :disabled="isLoading || params.manning_id === ''"
              @change="resetList">
              <option :value="1">ACTIVE</option>
              <option :value="0">INACTIVE</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-9 text-center d-flex align-items-center mt-3">
        <nav aria-label="..." v-if="pagination.from !== null">
          <ul class="pagination text-smallest mb-0 pb-0">
            <li
                class="page-item"
                :class="{ disabled: pagination.currentPage === 1 || pagination.from === 0 }"
            >
              <button class="page-link" @click="setPage(1)" :disabled="params.manning_id === ''">First</button>
            </li>

            <li
                v-for="page in paginationPages"
                :key="page"
                class="page-item"
                :class="{
                disabled: page === '...',
                active: page === pagination.currentPage,
              }"
            >
              <button class="page-link" @click="setPage(page)">
                {{ page }}
              </button>
            </li>

            <li
                class="page-item"
                :class="{
                disabled: pagination.currentPage === pagination.lastPage || pagination.from === 0,
              }"
            >
              <button class="page-link" @click="setPage(pagination.lastPage)" :disabled="params.manning_id === ''">
                Last
              </button>
            </li>
          </ul>
        </nav>
        <small v-if="pagination.from == null">{{ `No Records found` }}</small>
        <small class="mx-3" v-else>{{
            `${pagination.from} to ${pagination.to} of ${pagination.total}`
          }}</small>
      </div>
      <div class="col-3 text-center d-flex justify-content-end align-items-center">
        <button id="generateReport" class="btn btn-primary btn-xs p-1 d-flex align-items-center mr-2"
                @click="() => downloadList('pdf')"
                :style="{cursor: generateMode ? 'default' : 'pointer'}"
                :disabled="generateMode">
          <i class="fas fa-file-pdf fa-2x mx-1"></i>
          Generate PDF Report
        </button>

        <button id="generateReport" class="btn btn-primary btn-xs p-1 d-flex align-items-center"
                @click="() => downloadList('excel')"
                :style="{cursor: generateMode ? 'default' : 'pointer'}"
                :disabled="generateMode">
          <i class="fas fa-file-excel fa-2x mx-1"></i>
          Generate Excel Report
        </button>
      </div>

      <div class="col col-12">
        <table class="table table-hover table-bordered table-template-1 text-small table-striped my-2 sticky-header">
          <thead>
          <tr>
            <th width="1">No</th>
            <th>Last Name</th>
            <th>First Name</th>
            <th>Middle Name</th>
            <th>Suffix</th>
            <th>Rank</th>
            <th>IPN</th>
            <th>Activity Code</th>
            <th></th>
          </tr>
          </thead>
          <tbody class="text-small">
          <tr v-if="isLoading">
            <td colspan="100%">
              <app-loading></app-loading>
            </td>
          </tr>

          <template v-else>
            <tr v-for="(crew, index) in crewAccounts.data" :key="crew.id">
              <td class="text-center">{{ index + pagination.from }}</td>
              <td class="text-center">{{ crew.last_name }}</td>
              <td class="text-center">{{ crew.first_name }}</td>
              <td class="text-center">{{ crew.middle_name }}</td>
              <td class="text-center">{{crew.suffix}}</td>
              <td class="text-center">{{crew.rank}}</td>
              <td class="text-center">{{crew.ipn}}</td>
              <td class="text-center">{{crew.code}}</td>
              <td class="text-center">
                 <router-link
                  :to="{
                    name: 'CrewActivity',
                    params: { id: crew.id },
                  }"
                  class="btn btn-sm btn-xs btn-outline-info font-weight-bolder mr-1 ml-auto"
                  target="_blank"
                >
                  View
              </router-link>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <download-pdf-loading></download-pdf-loading>
    <download-excel-loading></download-excel-loading>
  </div>
</template>

<style scoped>
</style>
